import React, { useCallback, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import CustomSelect from './CustomSelect';
import { useActiveUserContext } from 'contexts/ActiveUserContext';
import { Button } from 'antd';
import Vocabulary, { getVocabulary } from './Vocabulary';
import ModalUtil from 'utils/modalUtil';
import ExceptionAPI from 'restAPI/ExceptionAPI';
import CreateExceptionFormPopup from 'views/Inventory/Exception/CreateExceptionFormPopup';

const ExceptionSelectWithAddButton = ({ showAddButton = true, onCreate, bucket, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [exceptions, setExceptions] = useState();
  const { history } = rest;

   const exceptionPayload = useMemo(() => {
      let filters = {};
      let payload;
      const { findingIds, filterMap } = bucket;
      if (!_.isEmpty(filterMap)) {
        filters = _.mergeWith({}, ...(_.compact(Object.values(filterMap))), (existing, incoming) => {
          if (Array.isArray(existing)) {
            return _.uniq(existing.concat(incoming));
          }
        });
      } else if (findingIds.length) {
        filters = {
            id_term: [...findingIds],
          }
      }
      if (!_.isEmpty(filters)) {
        payload = { "findingFilterRequest": { filters } };
      }
      return payload;
    }, [bucket]);

  const activeUser = useActiveUserContext();


  useEffect(() => {
    if(_.isEmpty(exceptionPayload)) return;
    const { promise, cancel } = ExceptionAPI.getOpenException(exceptionPayload);
    promise.then((res) => {
      setExceptions(res.data.map(option => ({ label: option.name, value: option.id })));
    }, _.noop);
    return cancel;
  }, [exceptionPayload]);

  const onButtonClick = useCallback(() => {
    setOpen(false);

    ModalUtil.show({
      content: <CreateExceptionFormPopup activeUser={activeUser} history={history} />,
      afterClose: (createdException) => {
        if (createdException) {
          setTimeout(() => {
            const updatedExceptions = [{ label: createdException.name, value: createdException.id }, ...(exceptions || [])];
            setExceptions(updatedExceptions);
            onCreate(createdException);
          }, [500]);
        }
      }
    });
  }, [activeUser, exceptions, history, onCreate]);

  return (
    <>
      <CustomSelect
        {...rest}
        style={{ width: "56%" }}
        open={open}
        onDropdownVisibleChange={setOpen}
        placeholder={<>Select <Vocabulary name={"exception"} /></>}
        loading={_.isNull(exceptions)}
        options={exceptions}
      />
      { showAddButton && <Button className="text-ellipsis" title={`Create New ${getVocabulary("exception")}`} style={{ width: "40%", float: 'right' }} name={'exception'} block onClick={onButtonClick}><>Create New <Vocabulary name={"exception"} /></></Button> }
    </>
  )
}

export default ExceptionSelectWithAddButton;
